module.exports = __webpack_public_path__ + "img/snowa_logo.fc25299.png";